import React from "react";
import StackedBarChart from "../components/Dashboard/Tabs/Legacy/Table/StackedBarChart";
import {fetchBlob} from "./functions";
import {Params} from "./customAxios";

export const customValueGenerator = (fun: Function) => (cellProps: any) => {
    const field = cellProps.field;
    const value = cellProps.dataItem[field];
    return <td>{fun(value)}</td>;
};

export const toFixedDate = customValueGenerator(
    (date: string) => new Date(date)
            .toISOString()
            .split("T")[0]
            .split("-")
            .reverse()
            .join("-")
);

export const toMoneyValue = customValueGenerator(
    (num: number) => "$" + (Math.round((num + Number.EPSILON) * 100) / 100).toLocaleString()
);

export const toPercentValue = customValueGenerator((x: string) => x + " %");

export const toStackedBarChart = customValueGenerator((data: any) => {
    return (
        <StackedBarChart data={data}/>
    )
});

export const generateExportButton = (endpoint: string, params: Params, method: string, buttonName: string) => {
    return (): JSX.Element => (
        <button className="k-button" type="submit" onClick={() => fetchBlob(endpoint, params, method)}>
            {buttonName}
        </button>
    );
}
